import { Text } from '@ksyos/design-system';
import type { ProcessQuestionnairesProgressStatusItem } from '@common/interfaces/api/processesApi';
import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { QuestionnaireName } from '@common/enums';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { ProgressBar } from '@frontend/components/elements/ProgressBar';

export function addOsasQuestionnaireProgressBars<
    ReadData extends {
        questionnaireProgressItems: ProcessQuestionnairesProgressStatusItem[];
    },
>(readSections: IProcessActivityReadSection[], map: ComponentsMap): void {
    const questionnaireProgressItems = getProcessActivityReadSectionItem<ReadData>()(
        readSections,
        'questionnaireProgressItems'
    );

    if (!questionnaireProgressItems) {
        return;
    }

    const componentToRender = (
        <>
            {questionnaireProgressItems.value.map((questionnaireProgress) => {
                return (
                    <ProgressBar
                        key={questionnaireProgress.questionnaireId}
                        percentage={questionnaireProgress.percentage}
                        statusText={questionnaireProgress.statusText}
                        title={
                            <Text>{questionnaireProgress.name === QuestionnaireName.osasHsdq ? 'HSDQ' : 'ESS'}</Text>
                        }
                    />
                );
            })}
        </>
    );

    map.set(questionnaireProgressItems.key, componentToRender);
}
